import { marchPrayerTimes } from './months/march';
import { aprilPrayerTimes } from './months/april';
import { mayPrayerTimes } from './months/may';
import { junePrayerTimes } from './months/june';
import { julyPrayerTimes } from './months/july';
import { augustPrayerTimes } from './months/august';
import { septemberPrayerTimes } from './months/september';
import { octoberPrayerTimes } from './months/october';
import { novemberPrayerTimes } from './months/november';
import { decemberPrayerTimes } from './months/december';




export const fallbackPrayerTimes = {
  "3": marchPrayerTimes,
  "4": aprilPrayerTimes,
  "5": mayPrayerTimes,
  "6": junePrayerTimes,
  "7": julyPrayerTimes,
  "8": augustPrayerTimes,
  "9": septemberPrayerTimes,
  "10": octoberPrayerTimes,
  "11": novemberPrayerTimes,
  "12": decemberPrayerTimes,
};

export type PrayerTimeData = {
  fajr: string;
  shoruk: string;
  dhuhr: string;
  asr: string;
  maghrib: string;
  isha: string;
};